export default __webpack_public_path__ + "static/media/icon_18.31ad4a85.png";